import $ from 'jquery';
$(function() {
	// --- Mobile menu (mobile) ---

// Open/Close navigation - Mobile Menu will not closed until user clicks on close icon.

	$( '.mobile-nav-button' ).click( function () {

		var _this = $( this );

		// Sub navigation has the same z-index - it should be changed before sliding down
		if ( ! _this.hasClass( 'opened' ) ) {
			$( '.header-mobile, .header-mobile-bar' ).css( 'z-index', 105 );
		} else {
			$( '.header-mobile, .header-mobile-bar' ).css( 'z-index', 103 );
		}
		// If header search is opened - close it
		if ( $( '.header-search' ).hasClass( 'active' ) ) {
			$( '.mobile-search-button' ).click();
		}

		_this.toggleClass( 'opened' );

		const headerMobileBar = $('.header-mobile-bar');

		headerMobileBar.addClass( 'opened' );

		$( '.mobile-nav' ).slideToggle(
			// After sliding up, change the z-index so the sub navigation shadow is visible
			function () {
				if ( ! _this.hasClass( 'opened' ) && ! $('.header-search').hasClass('active') ) {
					$( '.header-mobile' ).css( 'z-index', 103 );
					headerMobileBar.removeClass('opened');
				}
			}
		)

		$( 'body' ).toggleClass( 'overflow-hidden' );

		$( '.body-overlay' ).fadeToggle();
	} );

// Show submenu (slide to the right)

	//Trigger click of menu-submenu-back from ghost button
	const ghostMenuSubmenuBack = document.querySelector('.menu-submenu-back-ghost');
	const menuL1s = document.querySelectorAll('.mobile-nav .menu-l1');
	if(ghostMenuSubmenuBack){
		ghostMenuSubmenuBack.addEventListener('click', () => {

			menuL1s.forEach(menuL1 => {
				const menuL2s = document.querySelectorAll('.mobile-nav .menu-l2');
				$(ghostMenuSubmenuBack).css('visibility', 'hidden');
				//Order is important
				menuL2s.forEach(menuL2 => {
					if(menuL2.style.display === 'block'){
						const subMenu = menuL2.querySelector('.menu-submenu-back');
						subMenu.click();
						console.log(ghostMenuSubmenuBack, 'in l2');
						$(ghostMenuSubmenuBack).css('visibility', 'visible');
					}
					else if(menuL1.style.display === 'block'){
						const subMenu = menuL1.querySelector('.menu-submenu-back');
						subMenu.click();
						$(ghostMenuSubmenuBack).css('visibility', 'hidden');
						console.log(ghostMenuSubmenuBack, 'in l1');
					}
				})
			})
		})
	}

	$( '.mobile-menu .menu-parent > a' ).click( function ( e ) {
		e.preventDefault()
		var mySubmenu = $( this ).parent().find( '> .menu-submenu' )
		mySubmenu.show()
		$(ghostMenuSubmenuBack).show();
		var newLeft = parseInt( $( '.mobile-menu' ).css( 'left' ) ) - mySubmenu.position().left
		$( '.mobile-menu' ).css( 'left', newLeft )
	} )

// Hide submenu (slide to the left)

	$( 'button.menu-submenu-back, li.menu-submenu-back a' ).click( function ( e ) {
		e.preventDefault()
		var mySubmenu = $( this ).parents( '.menu-submenu' ).first(),
			newSubmenu,
			isZeroLevel;

		if ( $( this ).parent().hasClass( 'menu-submenu-title-wrapper' ) ) {
			newSubmenu = $( this ).parents( '.menu-l0' )
			isZeroLevel = true;
		} else {
			newSubmenu = $( this ).parents( '.menu-l1' )
			isZeroLevel = false;
		}
		var newLeft = parseInt( $( '.mobile-menu' ).css( 'left' ) ) + newSubmenu.width()
		$( '.mobile-menu' ).css( 'left', newLeft )
		setTimeout( function () {
			mySubmenu.hide()
		}, 500 )
	} )

// Sub-navigation mobile button

	$( '.subnav-mobile-button' ).click( function ( e ) {
		e.preventDefault()
		$( this ).toggleClass( 'opened' )
		$( this ).parent().find( '> ul' ).slideToggle()
	} )

// --- Resizing function for menus ---

	var myScreenSize = getScreenSize()

	function getScreenSize() {
		if ( $( window ).width() > 1200 ) {
			return 'M'
		} else {
			return 'S'
		}
	}

// Remove all classes and styles to hide menus when we change screen type

	$( window ).resize( lodash.debounce(
		function () {
			var newSize = getScreenSize()

			if ( newSize != myScreenSize ) {
				$( '.body-overlay, .mobile-nav, .mobile-menu, .menu-submenu, .menu-submenu2, .sub-navigation > ul, .sub-navigation .menu-parent nav' ).attr( 'style', '' )
				$( 'body' ).removeClass( 'nooverflow' )
				$( '.header-topbar-wrapper .header-nav a, .header-mobile-bar, .mobile-nav-button, .sub-navigation .menu-parent, .subnav-mobile-button' ).removeClass( 'opened' )
				$( '.menu-parent' ).removeClass( 'active' )
			}

			myScreenSize = getScreenSize()
		}, 100
	) )
});
